
import React from 'react';
import { motion } from 'framer-motion';

export default function StoryCard({ icon: Icon, title, description, colorClass, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay }}
      className="bg-[hsl(var(--cream-white))] rounded-[16px] p-8 premium-shadow border border-[hsl(var(--soft-grey))] flex flex-col items-center text-center group"
    >
      <motion.div 
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 200, delay: delay + 0.2 }}
        className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 bg-background border border-[hsl(var(--soft-grey))] shadow-sm`}
      >
        <motion.div
          animate={{ y: [0, -5, 0] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        >
          <Icon className={`w-10 h-10 ${colorClass}`} />
        </motion.div>
      </motion.div>
      <h3 className="text-xl font-semibold mb-3 text-[hsl(var(--charcoal))]">{title}</h3>
      <p className="text-[hsl(var(--charcoal))]/80 leading-relaxed">{description}</p>
    </motion.div>
  );
}
